// extracted by mini-css-extract-plugin
module.exports =  {"root":"j27_2rj6MnQlijinAn1N","termsText":"g7n6NcAToFPDyJgt3OKU","termsLink":"AXtp14UzC1DEZBM2pSEY"};